import { ComponentProps } from 'react';
import { NavLink } from 'react-router-dom';

import { useInstanceId } from '@frontend/hooks';

type NavlinkProps = ComponentProps<typeof NavLink>;

export function NamespacedNavlink(props: NavlinkProps) {
  const { instanceId } = useInstanceId();
  const { to, ...rest } = props;
  const namespacedTo =
    typeof to === 'string' && to.startsWith('/') ? `/instances/${instanceId}${to}` : to;

  return <NavLink to={namespacedTo} {...rest} />;
}
